import NiceModal from "@ebay/nice-modal-react";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputImage from "components/inputs/image/InputImage";
import QuillEditor from "components/inputs/richEditor/QuillEditor";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { decode, validateInputs } from "shared/utils/Utils";

function TestUploadPage() {
    const inputs = useRef([]);
    const [product, setProduct] = useState();
    const onClick = () => {
        let data = {
            productDetailImg: ""
        }
        
        validateInputs(inputs.current).then((result) => {

            if (result.isValid) {
                data.productDetailImg = inputs.current[0].getValue();
                
            } else {
                // toast.error(`${inputs.current[result.index].getName()} 항목을 확인해주세요`, {
                //     autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                // });
            }


        });
    }
    const testClick = () => {
        

    }
    return (
        <Container maxWidth={1200}>
            <P weight={"bold"} size={24}>테스트 업로드용 페이지</P>
            <FlexChild>
                <HorizontalFlex gap={30}>
                    <FlexChild width={"20%"} >
                        <P>액상배경 이미지 : </P>
                    </FlexChild>
                    <FlexChild>
                        <InputImage ref={el => (inputs.current[0] = el)} name={"액상 배경"} path={"product/"} labelWidth={0} cropWidth={486} cropHeight={416} value={product && product.image ? product.image : ""} maxSizeMb={1} />
                    </FlexChild>
                </HorizontalFlex>
            </FlexChild>
            {/* <FlexChild>
                <HorizontalFlex gap={30}>
                    <FlexChild width={"20%"} >
                        <P>카테고리 이미지 : </P>
                    </FlexChild>
                    <FlexChild>
                        <InputImage ref={el => (inputs.current[0] = el)} name={"액상 배경"} path={"product/"} labelWidth={0} value={product && product.image ? product.image : ""} maxSizeMb={1} />
                    </FlexChild>
                </HorizontalFlex>
            </FlexChild> */}
            {/* <FlexChild>
                <HorizontalFlex gap={30}>
                    <FlexChild width={"20%"} >
                        <P>상품상세 이미지 : </P>
                    </FlexChild>
                    <FlexChild height={"100%"}>
                        <div style={{ maxWidth: "1200px" }}>
                            <QuillEditor ref={el => (inputs.current[0] = el)} name={"상세"} value={product && product.content ? product.content : ""} path={"product/" + "product.id"} preview={true} />
                        </div>
                    </FlexChild>
                </HorizontalFlex>
            </FlexChild> */}
            <FlexChild>
                <CustomButton text={"등록하기"} onClick={onClick} />
                <CustomButton text={"DECODE"} onClick={testClick} />
                
            </FlexChild>
        </Container>
    );
}

export default TestUploadPage;